import {
    INIT_APPLICATION,
    PROGRESS_REPORT,
    FINAL_REPORT,
    LOCAL_SAE_REPORT,
    SUSAR_REPORT,
    PROTOCOL_DEVIATION_REPORT,
    MISCELLANEOUS_REPORT,
    CTC,
    CTI,
    FULL_REVIEW,
    PHASE_1_REVIEW,
    EXPEDITED_REVIEW,
    AMENDMENT_FORM,
} from 'utility/postApprovalLookUp';
import { reviewResultDecision } from 'utility/postApprovalLookUp';

const useConfirmReviewResultData = () => {
    // const reviewResultDecision = [
    //     {
    //         key: 0,
    //             display: 'Approved',
    //     },
    //     {
    //         key: 1,
    //             display: 'Acknowledged',
    //     },
    //     {
    //         key: 2,
    //             display: 'Channel for Full Review',
    //     },
    //     {
    //         key: 3,
    //             display: 'Request for Modification',
    //     },
    //     {
    //         key: 4,
    //             display: 'Disapproved',
    //     },
    // ];

    const decisionMapingList = {
        [INIT_APPLICATION]: {
            [FULL_REVIEW]: [0, 3, 4],
            [PHASE_1_REVIEW]: [0, 3, 4],
            [EXPEDITED_REVIEW]: [0, 3, 2],
        },
        [PROGRESS_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [FINAL_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [LOCAL_SAE_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [SUSAR_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [PROTOCOL_DEVIATION_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [MISCELLANEOUS_REPORT]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [CTC]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [CTI]: {
            [FULL_REVIEW]: [1, 3, 4],
            [PHASE_1_REVIEW]: [1, 3, 4],
            [EXPEDITED_REVIEW]: [1, 3, 2],
        },
        [AMENDMENT_FORM]: {
            [FULL_REVIEW]: [0, 3, 4],
            [PHASE_1_REVIEW]: [0, 3, 4],
            [EXPEDITED_REVIEW]: [0, 3, 2],
        },
    };

    const getChoicesList = (documentType, typeOfReview) => {
        if (decisionMapingList[documentType] && decisionMapingList[documentType][typeOfReview]) {
            const list = decisionMapingList[documentType][typeOfReview].map(key => {
                const index = reviewResultDecision.findIndex(item => item.key === key);
                return reviewResultDecision[index];
            });
            return list;
        };

        return [];
    };

    return {
        getChoicesList,
    };
};
export default useConfirmReviewResultData;